import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import { WbDateYearFormat } from '../../utils/common';
import {
    RangePicker,
} from '@workboard/wobo-ui'
import styled from 'styled-components'
import Template from './presets';
import { v4 as uuid } from 'uuid';

const StyledRangePicker = styled(RangePicker)`
    & .DateRangePicker {
        width: 260px;
    }
    & .DateRangePicker,
    & .DateRangePickerInput {
        height: 32px;
        width: auto;
        padding-right: 0px;
    }
    & .DateRangePickerInput {
        margin-right: 5px;
    }
    & .DateRangePickerInput_calendarIcon {
        height: 32px;
        width: 32px;
        max-width: 32px;
    }
    & .DateRangePickerInput_arrow{
        margin: 0 8px 0 0;
    }
    & .DayPicker_weekHeader_ul{
        margin: 0px;
        padding-left: 0px;
    }
`;

const DateRangePopover = (props) => {

    const [startDate, setStart] = useState(props.start_date || 0)
    const [endDate, setEnd] = useState(props.end_date || null)
    const [start, setS] = useState(props.start_date || 0)
    const [end, setE] = useState(props.end_date || null)
    const [range, setRange] = useState({start: '', end: ''})
    const [key, setKey] = useState(uuid());

    const onCancel = () => {
        setTimeout(() => {
            const focusEl = $("button.DateRangePickerInput_calendarIcon");
            if (focusEl) focusEl.focus();
        })
        setKey(uuid());
    }

    const onClear = (e) => {
        setDateRange(props.start_date, props.end_date)
        props.onClear(e)
        setKey(uuid());
    }

    const onApply = (e) => {
        props.onChange(e, range)
        setKey(uuid());
    }

    const getSystemOffset = () => {
        return WbDateYearFormat.getSystemOffset();
    }

    const getFormatDate = (date, dateformat) => {
        const utcDate = isDSTdate(date, true);
        return moment(utcDate).format(dateformat);
    }

    const isDSTdate = (date, returnValue = false) => {
        let utcDate = moment.utc(date);
        const isDst = moment().isDST();
        if (isDst) {
          utcDate = utcDate.clone().add(1, 'hour');
        }
        if (returnValue) {
          return utcDate.valueOf();
        }
        return new Date(utcDate.valueOf());
    }

    const handleRangeChange = (r) => {
        setRange(r);
    }

    const setDateRange = (s, e) => {
        let _startDate = s, _endDate = e;

        if (parseInt(_startDate) > 0) {
            _startDate = parseInt(_startDate) * 1000 - getSystemOffset();
        }
        if (parseInt(_startDate) > 0) {
            _endDate = parseInt(_endDate) * 1000 - getSystemOffset();
        }
        setStart(getFormatDate(_startDate, 'MM/DD/YYYY'))
        setEnd(getFormatDate(_endDate, 'MM/DD/YYYY'))
    }
    const setDate = (s, e) => {
        let _startDate = s, _endDate = e;

        if (parseInt(_startDate) > 0) {
            _startDate = parseInt(_startDate) * 1000 - getSystemOffset();
        }
        if (parseInt(_startDate) > 0) {
            _endDate = parseInt(_endDate) * 1000 - getSystemOffset();
        }
        setS(getFormatDate(_startDate, 'MM/DD/YYYY'))
        setE(getFormatDate(_endDate, 'MM/DD/YYYY'))
    }

    useEffect(() => {
        setDate(props.start_date, props.end_date)
        setDateRange(props.start_date_string, props.end_date_string)
    }, [props])

    const Presets = useCallback(
        () => (
          <Template
            {...props}
            onDismiss={onCancel}
            onSubmit={onApply}
            onReset={onClear}
          />
        ),
        [onCancel, onApply],
    );
    
    return <StyledRangePicker
        key={key}
        start={startDate}
        end={endDate}
        onChange={handleRangeChange}
        presetsTemplate={Presets}
        onOutsideClick={onCancel}
        anchorDirection={props.anchorDirection}
        scrollModalIntoView={props.scrollModalIntoView}
        isOutsideRange={(day => day.isAfter(end) || day.isBefore(start))}
        minDate={new Date(moment(start).format('YYYY, MM, DD'))}
        maxDate={new Date(moment(end).format('YYYY, MM, DD'))}
    />
}

export default DateRangePopover;